<template>
    <div>
        <div v-if="isEmpty">No meta data defined</div>
        <el-form label-position="top">
            <el-form-item
                :label="key"
                :key="key"
                v-for="(val, key) in metaData"
            >
                <el-input
                    v-model="value[key]"
                    @input="updateValue"
                    type="textarea"
                ></el-input>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    props: ['value', 'label'],
    computed: {
        isEmpty() {
            return !Object.keys(this.metaData).length;
        },
        metaData() {
            if (!this.value) {
                return {};
            }
            return this.value;
        },
    },
    methods: {
        updateValue() {
            this.$emit('input', this.metaData);
        },
    },
};
</script>



// WEBPACK FOOTER //
// MetaData.vue?2faef90c